import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const examplePopulatedLiquidTemplate = {
  name: "examplePopulatedLiquidTemplate" as const,
  input: z.object({ schemaType: createEnum(SchemaType), template: z.string() }),
  output: z.discriminatedUnion("success", [
    z.object({ success: z.literal(true), template: z.string() }),
    z.object({ success: z.literal(false), error: z.string() }),
  ]),
};
